<h3 class="group-name">
  {{ groupData?.displayAlias | ellipsis: 22 }}
  <span *ngIf="groupData.isDefault">
    (default)
    <img
      [src]="'../../assets/images/help.png'"
      class="question-icon"
      [matTooltipPosition]="'below'"
      [matTooltip]="infoTooltipText"
    />
  </span>
  <img
    *ngIf="
      groupData &&
      groupData.displayAlias &&
      infoTooltipObj[groupData.displayAlias]
    "
    [src]="'../../assets/images/help.png'"
    class="question-icon"
    [matTooltipPosition]="'below'"
    [matTooltip]="infoTooltipObj[groupData.displayAlias]"
  />
  <button
    class="icon-btn"
    (click)="deleteGroup(groupData)"
    *ngIf="canBeDeleted && !groupData.isDefault"
    [matTooltipPosition]="'below'"
    [matTooltip]="deleteGroupTooltipText"
  >
    <img [src]="'../../assets/images/remove.png'" class="circle-icon" />
  </button>
  <button
    class="icon-btn edit-icon-btn"
    (click)="editGroup(groupData)"
    *ngIf="groupData.isEditable"
    [matTooltipPosition]="'below'"
    [matTooltip]="editGroupTooltipText"
  >
    <img [src]="'../../assets/images/edit.png'" class="circle-icon" />
  </button>
  <button
    class="icon-btn move-btn"
    (click)="moveRight(groupData)"
    *ngIf="showRightArrow"
    [matTooltipPosition]="'below'"
    [matTooltip]="moveGroupTooltipText"
  >
    <img [src]="'../../assets/images/move_right.svg'" class="circle-icon" />
  </button>
  <button
    class="icon-btn move-btn"
    (click)="moveLeft(groupData)"
    *ngIf="showLeftArrow"
    [matTooltipPosition]="'below'"
    [matTooltip]="moveGroupTooltipText"
  >
    <img [src]="'../../assets/images/move_left.svg'" class="circle-icon" />
  </button>
</h3>
<div class="group-body">
  <div
    class="top-bar"
    *ngIf="groupData?.results && groupData?.results.length > 0"
  >
    <mat-checkbox
      [checked]="false"
      [(ngModel)]="groupData.selectAll"
      (change)="selectAllClicked()"
      class="select-all-box"
    ></mat-checkbox>
    <mat-form-field class="example-full-width">
      <input
        matInput
        class="example-full-width"
        [ngModel]="searchTerm"
        (ngModelChange)="searchTermChanged($event)"
      />
      <mat-placeholder class="group-placeholder">{{
        placeholderText
      }}</mat-placeholder>
    </mat-form-field>
  </div>
  <div class="bottom-bar">
    <mat-checkbox
      *ngFor="let result of getResults()"
      class="check-box"
      [checked]="false"
      [labelPosition]="'start'"
      [(ngModel)]="result.checked"
      (change)="groupChecked()"
      [matTooltipPosition]="'below'"
      [matTooltip]="
        result && result.name && result.name.length > maxLength
          ? result.name
          : null
      "
    >
      {{
        result && result.name && result.name.length > maxLength
          ? (result.name | slice: 0:maxLength) + "..."
          : result?.name
      }}
    </mat-checkbox>
    <p *ngIf="filteredItems && filteredItems.length == 0" class="no-codes">
      No {{ groupingUnitPlural }} match the current filter
    </p>
    <p
      *ngIf="
        !groupData?.results ||
        (groupData?.results && groupData?.results.length == 0)
      "
      class="no-codes"
    >
      No {{ groupingUnitPlural }} in this category... yet!
    </p>
  </div>
</div>
